
const imageUrl = (title) => {
  return `/imgs/case/smart/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    items: [
      '面向2X多家OEM工厂，提供提货、干线运输和交仓服务。',
      '面向3XXX+家直营和加盟店提供城市配送服务。',
      '日均处理4K个销售PO。(X表示商业机密，不便于说明)',
    ]
  },
  method: imageUrl('method'),
  value: [
    {
      title: '实现订单全程自动可视化，跟单成本降低45万元/年',
      description: '利用移动APP、电子围栏和TMS策略获取全程的信息，以承运商KPI为管理手段，实现了运输过程的' +
        '全程自动化的可视化管理。信息跟踪人员由原来的5人减为0人，直接每年减少45万元。',
      img: imageUrl('value1')
    },
    {
      title: '实现与企业系统对接，日报发送效率提升200%以上',
      description: '通过EDI实时与客户系统进行对接，省去了整理、发送日报的工作，由原来的每天发送一次日报改为 系统实时发送。',
      img: imageUrl('value2')
    },
    {
      title: '实现货物的自动分拣，分拣效率升300%,人工成本降低50%',
      description: '使用PDA设备对货物进行自动分拣，在相同的准确率水平下，分拣速度由原来的3小时降为1个小时，且分拣人工投入减少一半。',
      img: imageUrl('value3')
    },
    {
      title: '实现运输异常线上化动态管理，使客服质量提升20%',
      description: '改变了异常的管理方式，作业现场通过APP及时上报异常，客户在TMS中动态的查询并及时沟通，及时处理，形成异常管理闭环，大幅度降低异常投诉比例。',
      img: imageUrl('value4')
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/smart.js